import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';

import { ComparisonResponse, FetchComparisonParams } from './types';

const fetchComparison = async (params: FetchComparisonParams) => {
  const { data } = await api.get(`/spold/comparison`, { params });

  return data;
};

const useComparison = (params?: FetchComparisonParams) =>
  useQuery<ComparisonResponse, AxiosError>({
    queryKey: ['comparison', params],
    queryFn: () => fetchComparison(params as FetchComparisonParams),
    enabled: Boolean(params),
    staleTime: Infinity,
  });

export default useComparison;
